<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-card v-if="blogDetails">
      <div class="mb-3 w-100 d-flex align-items-center justify-content-between">
        <h1 v-if="blogDetails">Edit Seo in '{{ blogDetails.title }}'</h1>
      </div>
      <b-row>
        <b-col cols="12" md="6">
          <b-form @submit.prevent>
            <b-form-group label="Seo title" label-for="seoTitle">
              <b-form-input
                  id="seoTitle"
                  trim
                  placeholder=""
                  v-model="blogDetails.seoTitle"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="12" md="6">
          <b-form @submit.prevent>
            <b-form-group label="Seo Url" label-for="seourl">
              <b-form-input
                  id="seourl"
                  trim
                  placeholder=""
                  v-on:focus="$event.target.select()"
                  v-model="allCharactersToDash"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="12">
          <b-form @submit.prevent>
            <b-form-group label="Seo Description" label-for="seoDescription">
              <b-form-textarea
                  id="seoDescription"
                  trim
                  placeholder=""
                  v-model="blogDetails.seoDescription"
              />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <!--- serp Desktop --->
          <div class="serp-preview d-lg-flex p-3 d-none flex-column align-items-start">
            <div class="serp-title">
              <h4 style="color: rgb(26, 13, 171) !important">
                {{ blogDetails.seoTitle }}
              </h4>
            </div>
            <div class="serp-url">
              <!--              <span class="serp-arrow"></span>-->
              <h5 class="d-flex align-items-center flex-wrap"
                  style="color: rgb(0, 102, 33) !important">
                <span>
                  {{ `https://ariaexport.com${langs[blogDetails.languageId]}/blogs/` }}
                </span>
                <span style="overflow-wrap: anywhere">{{ allCharactersToDash }}</span>
              </h5>
            </div>
            <div class="serp-description">
              <h6 style="overflow-wrap: anywhere">
                {{ blogDetails.seoDescription }}
              </h6>
            </div>
          </div>
          <!--- serp Mobile --->
          <div class="serp-preview d-lg-none p-3 d-flex flex-column align-items-start">
            <div class="serp-title">
              <h6>
                {{ blogDetails.seoTitle }}
              </h6>
            </div>
            <div class="serp-url d-flex align-items-center flex-wrap">
              <small>
                {{ `https://ariaexport.com${langs[blogDetails.languageId]}/blogs/` }}
                <!--                <small class="serp-arrow"></small>-->
              </small>
              <small>{{ allCharactersToDash}}</small>
            </div>
            <div class="serp-description">
              <small>
                {{ blogDetails.seoDescription }}
              </small>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Seo meta" label-for="meta">
            <b-form-textarea
                id="meta"
                trim
                placeholder=""
                v-model="blogDetails.meta"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button variant="primary" @click="updateThisBlog">
          Update
        </b-button>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getASingleBlog();
  },
  data() {
    return {
      isLoading: false,
      blogDetails: null,
      langs: {
        2: '/fa',
        1: '',
        3: '/ar',
        4: '/ru',
        6: '/tr',
      },
    };
  },
  computed: {
    allCharactersToDash: {
      get: function () {
        return this.blogDetails.seourl;
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.blogDetails.seourl = newValue
          // Remove all characters that are NOT number
          this.blogDetails.seourl = this.blogDetails.seourl.replace(/[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\/\.]/g, "");
          this.blogDetails.seourl = this.blogDetails.seourl.replaceAll(' ', '-')
        } else if (!newValue || this.blogDetails.seourl === "") {
          this.blogDetails.seourl = null;
        }
      },
    },
  },
  methods: {
    async getASingleBlog() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleBlog = new GetASingleBlog(_this);
        getASingleBlog.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleBlog.fetch((response) => {
          if (response.isSuccess) {
            _this.blogDetails = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateThisBlog() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateBlogSeo = new UpdateBlogSeo(_this);
        updateBlogSeo.setRequestParamDataObj(_this.blogDetails);
        await updateBlogSeo.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "سئوی بلاگ با موفقیت ویرایش شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.getASingleBlog();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BContainer,
    BPagination,
    BFormRow,
    BCard,
    BMedia,
    BAvatar,
    BCardText,
    BTable,
    BMediaAside,
    BMediaBody,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BFormFile,
    BLink,
    BButton,
    BFormTextarea,
    BOverlay,
    BFormSelect,
  },
};
import {
  BContainer,
  BPagination,
  BFormRow,
  BCard,
  BMedia,
  BAvatar,
  BCardText,
  BTable,
  BMediaAside,
  BMediaBody,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BImg,
  BFormFile,
  BLink,
  BButton,
  BFormTextarea,
  BOverlay,
  BFormSelect,
} from "bootstrap-vue";
import {GetASingleBlog, UpdateBlogSeo} from "@/libs/Api/Blog";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
</script>
<style scoped>
.serp-arrow {
  border-bottom-color: rgb(0, 102, 33);
  border-bottom-style: solid;
  border-bottom-width: 0px;
  border-left-color: rgba(0, 0, 0, 0);
  border-left-style: solid;
  border-left-width: 4px;
  border-right-color: rgba(0, 0, 0, 0);
  border-right-style: solid;
  border-right-width: 4px;
  border-top-color: rgb(0, 102, 33);
  border-top-style: solid;
  border-top-width: 5px;
  color: rgb(128, 128, 128);
  cursor: default;
  font-family: arial, sans-serif;
  font-size: 11px;
  font-weight: bold;
  height: 0px;
  position: absolute;
  line-height: 27px;
  margin-left: 3px;
  margin-top: 6px;
  text-align: center;
  user-select: none;
  visibility: visible;
  white-space: nowrap;
  width: 0px;
}

.serp-title {
  color: rgb(26, 13, 171) !important;
  cursor: pointer;
  font-family: arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  line-height: 21.6px;
  text-align: left;
  text-decoration: none;
  visibility: visible;
  white-space: nowrap;
}

.serp-url {
  color: rgb(0, 102, 33) !important;
  font-family: arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  text-align: left;
  visibility: visible;
  white-space: nowrap;
}

.serp-description {
  color: rgb(84, 84, 84) !important;
  font-family: arial, sans-serif;
  font-size: 13px;
  font-weight: normal;
  line-height: 18.2px;
  text-align: left;
  visibility: visible;
  word-wrap: break-word;
}
</style>
